import "./HotelRevenueManagementConsultantIndia.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Contact from "./sections/Contact";
import Services from "./sections/Services";
import Consultancyfaq from "./sections/Consultancyfaq";
import RevenueAudit from "./sections/RevenueAudit";
import Footer from "@/reusable_sections/Footer";
export default function HotelRevenueManagementConsultantIndiaPage() {
  return <div>
      <Header />
      <Hero />
      <Contact />
      <Services />
      <Consultancyfaq />
      <RevenueAudit />
      <Footer />
    </div>;
}